import locale from "date-fns/locale/pt-BR";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  LocalizationProvider,
  TimePicker as TimePickerMui,
} from "@mui/x-date-pickers";

const TimePicker = ({
  id,
  label,
  name,
  className,
  minTime,
  maxTime,
  format,
  onChange,
  value,
  onClose,
  disabled,
  onClick,
  onClear,
  margin,
  variant,
  placeholder,
  shrink,
  required,
  sx,
  error,
  disableTextfield,
  ref,
  ampm,
  autoFocus = false,
  clearable = false,
  clearButtonPosition = "end",
  color = "primary",
  disableFuture = false,
  disablePast = false,
  fullWidth = false,
  minutesStep = 1,
  openPickerButtonPosition = "end",
  size = "medium",
}) => {
  const defaultSx = {
    margin: margin ? "1rem 1rem 0.5rem auto" : "auto",
    width: "100%",
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
      <TimePickerMui
        id={id}
        className={className}
        label={label}
        name={name}
        inputRef={ref}
        ampm={ampm}
        clearable={clearable}
        clearButtonPosition={clearButtonPosition}
        color={color}
        disableFuture={disableFuture}
        disablePast={disablePast}
        fullWidth={fullWidth}
        autoFocus={autoFocus}
        minTime={minTime}
        maxTime={maxTime}
        minutesStep={minutesStep}
        format={format}
        timezone="America/Bahia"
        onChange={onChange}
        onClear={onClear}
        onClick={onClick}
        openPickerButtonPosition={openPickerButtonPosition}
        size={size}
        slotProps={{
          textField: {
            error,
            required,
            variant,
            disabled: disableTextfield || disabled,
            placeholder,
            InputLabelProps: { shrink },
          },
        }}
        value={value}
        onClose={onClose}
        disabled={disabled}
        sx={{
          ...defaultSx,
          ...sx,
        }}
      />
    </LocalizationProvider>
  );
};

export default TimePicker;
